import styled from 'styled-components';
import { Accordion } from 'semantic-ui-react';

export const GroupNameTitle = styled.div`
  font-size: 16px !important;
  font-weight: 600;
  line-height: 1.75rem;
  white-space: pre;
  margin: 2rem 0 0.5rem 0;
`;

export const GroupsContainer = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
`;

export const FilesContainer = styled.div`
  margin-top: 0.5rem;
`;

export const SortContainer = styled.div`
  margin: 4px 0;
  padding: 10px;
  cursor: move;
  border: 2px solid;
`;

export const RolesContainer = styled.div`
  display: flex;
  column-gap: 5rem;
  margin-top: 1rem;
  flex-direction: row;
  flex-wrap: wrap;
`;

export const QuestionTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const StyledAccordion = styled(Accordion)`
width: 100% !important;
margin-top: 15px;
 .title {
   display: flex;
   align-items: baseline;
   justify-content: space-between;
   color: black !important;
 }
`

const QuestionHeaderWrapper = styled.div`
display: block !important;
align-items: center !important; 
justify-content: space-between !important;
`

export const El = {
  GroupNameTitle,
  GroupsContainer,
  FilesContainer,
  SortContainer,
  RolesContainer,
  QuestionTitleContainer,
  QuestionHeaderWrapper
};
